import React from "react";
import { ScalePattern, ScalePatternId } from "../../model/scales";


export function ScalePatternSelector({
    scalePatternProvider,
    selectedScalePatternId,
    setSelectedScalePatternId,
    buttonCSS
}: {
    scalePatternProvider: () => ScalePattern[],
    selectedScalePatternId?: ScalePatternId,
    setSelectedScalePatternId: (id?: ScalePatternId) => void,
    buttonCSS: (b: boolean) => string
}) {
    return (<div>
        <label>Interval Pattern</label>
        <ul className='midi-device-panel--list'>
            <li onClick={_ => setSelectedScalePatternId(undefined)}>---</li>

            {scalePatternProvider().map((p, i) =>
                <li
                    key={i}
                    value={p.name}
                    onClick={_ => setSelectedScalePatternId(p.id)}
                    className={buttonCSS(p.id === selectedScalePatternId)}
                    aria-label={`(${p ? p.pattern.intervals.join(', ') : ''})`}>
                    {p.name}
                </li>
            )}
        </ul>
    </div>);
}